export const ADD_RECOGNIZED_FILE = 'ADD_RECOGNIZED_FILE';
export const REMOVE_RECOGNIZED_FILE = 'REMOVE_RECOGNIZED_FILE';
export const ADD_WAITING_FILE = 'ADD_WAITING_FILE';
export const REMOVE_WAITING_FILE = 'REMOVE_WAITING_FILE';
export const CHECK_RECOGNIZED_FILES = 'CHECK_RECOGNIZED_FILES';
export const ADD_CLASSIFY_FILE = 'ADD_CLASSIFY_FILE';
export const REMOVE_CLASSIFY_FILE = 'REMOVE_CLASSIFY_FILE';
